import React from "react";

/**
 * Bottom-center branded watermark for all live streams + conference calls.
 * Follows the kids/main variant convention used by the existing top-right `Watermark`.
 */
export default function StreamWatermark({ variant = "main", size = "md" }) {
  const isKids = variant === "kids";
  const src = isKids ? "/kids-learn-play-logo.png" : "/tapintv-logo-v2.png";
  const label = isKids ? "Tap IN Kids" : "Tap IN TV";
  const h = size === "lg" ? "h-10 sm:h-12" : size === "sm" ? "h-5 sm:h-6" : "h-7 sm:h-9";

  return (
    <div
      data-testid={`stream-watermark-${variant}`}
      aria-hidden="true"
      className="pointer-events-none select-none absolute bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-2 px-3 py-1 rounded-full bg-black/45 backdrop-blur-sm"
    >
      <img src={src} alt="" draggable="false" className={`${h} w-auto drop-shadow-[0_0_10px_rgba(0,0,0,0.7)]`} />
      <span className="text-[10px] sm:text-xs font-display font-black tracking-[0.22em] uppercase text-white/90">
        {label}
      </span>
    </div>
  );
}
